"use client";

import { Skeleton } from "@/components/ui/feedback/skeleton";
import { cn } from "@/lib/utils";

export interface ContactEntitySkeletonProps {
  layout?: "card" | "row";
  className?: string;
}

/**
 * Loading skeleton for ContactEntity. Shape-matches the rendered
 * component so list height doesn't shift when data arrives.
 */
export function ContactEntitySkeleton({
  layout = "card",
  className,
}: ContactEntitySkeletonProps) {
  if (layout === "row") {
    return (
      <div
        className={cn(
          "flex items-center gap-3 border-b border-border bg-card px-3 py-2",
          className,
        )}
      >
        <div className="min-w-0 flex-1 space-y-1">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-3 w-1/2" />
        </div>
        <Skeleton className="h-7 w-16 shrink-0" />
        <Skeleton className="h-8 w-8 shrink-0" />
        <Skeleton className="h-8 w-8 shrink-0" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "border border-border bg-card p-3",
        className,
      )}
      style={{ boxShadow: "var(--shadow-warm-sm)" }}
    >
      <div className="mb-2 flex items-center gap-2">
        <Skeleton className="h-5 w-1/3" />
      </div>
      <div className="mb-2 space-y-1">
        <Skeleton className="h-3 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
      <div className="mb-3 flex flex-wrap gap-1">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-5 w-16" />
      </div>
      <div className="flex flex-wrap gap-2">
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-8 w-24" />
      </div>
    </div>
  );
}
